import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function pad2(n) {
    return String(n).padStart(2, "0");
}

function toYyyyMmDd(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

function getDefaultDateRange() {
    const now = new Date();
    const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return {
        from: toYyyyMmDd(firstOfMonth),
        to: toYyyyMmDd(today)
    };
}

async function fetchRoomEarningUsers({ uid, role, startTime, endTime, cursor, pageSize }) {
    const url = global.config.apiDomain + "/mc-live-room/web/room-earning/users";
    const params = {
        startTime,
        endTime,
        cursor,
        pageSize
    };
    if (uid != null) {
        params.uid = uid;
    }
    if (role != null && String(role).trim() !== "") {
        params.role = String(role).trim();
    }

    const res = await axios.get(url, { params });
    const payload = res && res.data ? res.data.data : null; // ApiResponse.ok(data)
    return {
        data: (payload && payload.data) || [],
        nextCursor: (payload && payload.nextCursor) || "END"
    };
}

async function withdrawRoomEarningGem({ userId, amount, exchangeMethod }) {
    const url = global.config.apiDomain + "/mc-live-room/web/room-earning/withdraw-gem";
    const res = await axios.post(url, {
        userId,
        amount,
        exchangeMethod
    });
    return res && res.data ? res.data : {};
}

async function fetchRoomEarningGemHistory({ userId, startTime, endTime }) {
    const url = global.config.apiDomain + "/mc-live-room/web/room-earning/gem-history";
    const params = { userId, startTime, endTime };
    const res = await axios.get(url, { params });
    const payload = res && res.data ? res.data.data : null;
    return {
        data: (payload && payload.data) || []
    };
}

const ROOM_EARNING_ROLE_OPTIONS = [
    "USER",
    "TESTER",
    "CUSTOMER-SUPPORTER",
    "ICOIN-MANAGER",
    "MANAGER",
    "SINGER",
    "SELLER",
    "BOT",
    "IDOL",
    "COLLABORATOR",
    "KTV"
];


function formatHistoryTimeByType(timestamp, type) {
    if (timestamp == null) return "";
    const d = new Date(timestamp);
    if (Number.isNaN(d.getTime())) return "";

    if (type === "INCREASE") {
        return d.toLocaleDateString("vi-VN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    }

    return d.toLocaleString("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}


function formatHistoryInteger(value) {
    if (value == null || value === "") return "—";
    const n = Number(value);
    if (!Number.isFinite(n)) return "—";
    return n.toLocaleString("vi-VN", { maximumFractionDigits: 0 });
}

function formatHistorySignedInteger(value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n === 0) return "0";
    const abs = Math.abs(n);
    const sign = n > 0 ? "+" : "-";
    return sign + abs.toLocaleString("vi-VN", { maximumFractionDigits: 0 });
}

function floorNumber(v) {
    const n = Number(v);
    if (!Number.isFinite(n)) return 0;
    return Math.floor(n);
}

function formatInt(v) {
    return floorNumber(v).toLocaleString("vi-VN");
}

function formatHistoryTransactionLabel(type, category) {
    if (type === "INCREASE") return "Tăng";
    if (category === "ICOIN_WITHDRAW") return "Giảm - ICOIN";
    if (category === "CASH_WITHDRAW") return "Giảm - Cash";
    return "Giảm";
}

function formatFixed2(v) {
    if (v == null || v === "") return (0).toLocaleString("vi-VN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const n = Number(v);
    if (!Number.isFinite(n)) return (0).toLocaleString("vi-VN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return n.toLocaleString("vi-VN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default class AdminRoomEarningPage extends Component {
    constructor(props) {
        super(props);
        const defaults = getDefaultDateRange();
        this.state = {
            searchUid: "",
            searchRole: "",
            searchFromDate: defaults.from,
            searchToDate: defaults.to,
            loading: false,
            loadingMore: false,
            errorMessage: "",
            results: [],
            pageSize: 10,
            usersNextCursor: "END",
            selectedUserForHistory: null,
            historyModalVisible: false,
            diamondHistory: [],
            historyPageSize: 10,
            historyLoading: false,
            historyFromDate: defaults.from,
            historyToDate: defaults.to,
            historyNextCursor: "END",
            selectedUserForWithdraw: null,
            selectedUserForWithdrawId: null,
            withdrawModalVisible: false,
            withdrawAmount: "",
            withdrawMethod: "CASH",
            withdrawSubmitting: false,
            availableDiamonds: 0,
            totalDiamondsNow: 0,
            maxWithdrawDiamonds: 0,
            onlineDetailModalVisible: false,
            selectedOwnerForOnlineDetail: null,
            ownerRoomsDetailList: []
        };
    }

    componentDidMount() {
        const { pageSize, searchFromDate, searchToDate, searchRole } = this.state;
        this.setState({ loading: true, loadingMore: false, errorMessage: "" });

        fetchRoomEarningUsers({
            uid: null,
            role: searchRole,
            startTime: searchFromDate,
            endTime: searchToDate,
            cursor: null,
            pageSize: pageSize
        })
            .then(response => {
                const data = response.data || [];
                this.setState({
                    results: data,
                    usersNextCursor: response.nextCursor || "END",
                    loading: false,
                    loadingMore: false,
                    errorMessage: data.length === 0 ? "Không có dữ liệu." : ""
                });
            })
            .catch((e) => {
                const msg = (e && e.response && e.response.data && e.response.data.message) || null;
                this.setState({
                    loading: false,
                    loadingMore: false,
                    results: [],
                    usersNextCursor: "END",
                    errorMessage: msg || "Có lỗi xảy ra khi tải dữ liệu."
                });
            });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleUidSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            this.handleSearch();
        }
    };

    handleSearch = async () => {
        const { searchUid, searchRole, searchFromDate, searchToDate, pageSize } = this.state;
        if (!searchFromDate || !searchToDate) {
            this.setState({
                errorMessage: "Bắt buộc chọn từ ngày và đến ngày (yyyy-MM-dd).",
                results: []
            });
            return;
        }

        if (searchFromDate > searchToDate) {
            this.setState({
                errorMessage: "Thời gian bắt đầu phải nhỏ hơn hoặc bằng thời gian kết thúc.",
                results: []
            });
            return;
        }

        const trimmedUid = (searchUid || "").trim();
        let uidNumber = null;
        if (trimmedUid !== "") {
            const parsed = parseInt(trimmedUid, 10);
            if (isNaN(parsed)) {
                this.setState({ errorMessage: "UID phải là số.", results: [] });
                return;
            }
            uidNumber = parsed;
        }

        this.setState({ loading: true, loadingMore: false, errorMessage: "" });

        try {
            const response = await fetchRoomEarningUsers({
                uid: uidNumber,
                role: searchRole,
                startTime: searchFromDate,
                endTime: searchToDate,
                cursor: null,
                pageSize: pageSize
            });

            const data = response.data || [];
            this.setState({
                results: data,
                usersNextCursor: response.nextCursor || "END",
                loading: false,
                loadingMore: false,
                errorMessage: data.length === 0 ? "Không có dữ liệu." : ""
            });
        } catch (e) {
            const msg = (e && e.response && e.response.data && e.response.data.message) || null;
            this.setState({
                loading: false,
                loadingMore: false,
                results: [],
                usersNextCursor: "END",
                errorMessage: msg || "Có lỗi xảy ra khi tải dữ liệu."
            });
        }
    };

    handleRefresh = () => {
        const { pageSize } = this.state;
        const defaults = getDefaultDateRange();
        this.setState(
            {
                searchUid: "",
                searchRole: "",
                searchFromDate: defaults.from,
                searchToDate: defaults.to,
                loading: true,
                loadingMore: false,
                errorMessage: "",
                results: [],
                pageSize: pageSize || 10,
                usersNextCursor: "END",
                selectedUserForHistory: null,
                historyModalVisible: false,
                diamondHistory: [],
                historyLoading: false,
                historyFromDate: defaults.from,
                historyToDate: defaults.to,
                historyNextCursor: "END",
                selectedUserForWithdraw: null,
                withdrawModalVisible: false,
                withdrawAmount: "",
                withdrawMethod: "CASH",
                withdrawSubmitting: false,
                availableDiamonds: 0,
                maxWithdrawDiamonds: 0,
                onlineDetailModalVisible: false,
                selectedOwnerForOnlineDetail: null,
                ownerRoomsDetailList: []
            },
            () => {
                fetchRoomEarningUsers({
                    uid: null,
                    role: this.state.searchRole,
                    startTime: this.state.searchFromDate,
                    endTime: this.state.searchToDate,
                    cursor: null,
                    pageSize: this.state.pageSize
                })
                    .then(response => {
                        const data = response.data || [];
                        this.setState({
                            results: data,
                            usersNextCursor: response.nextCursor || "END",
                            loading: false,
                            loadingMore: false,
                            errorMessage: data.length === 0 ? "Không có dữ liệu." : ""
                        });
                    })
                    .catch((e) => {
                        const msg = (e && e.response && e.response.data && e.response.data.message) || null;
                        this.setState({
                            loading: false,
                            loadingMore: false,
                            results: [],
                            usersNextCursor: "END",
                            errorMessage: msg || "Có lỗi xảy ra khi tải dữ liệu."
                        });
                    });
            }
        );
    };

    openHistoryModal = (user) => {
        const defaults = getDefaultDateRange();
        this.setState(
            {
                selectedUserForHistory: user,
                historyModalVisible: true,
                historyLoading: true,
                diamondHistory: [],
                historyFromDate: defaults.from,
                historyToDate: defaults.to,
                historyNextCursor: "END"
            },
            () => this.fetchHistoryPage(true)
        );
    };

    closeHistoryModal = () => {
        this.setState({
            selectedUserForHistory: null,
            historyModalVisible: false,
            diamondHistory: [],
            historyLoading: false,
            historyNextCursor: "END"
        });
    };

    fetchHistoryPage = async (isReset = false) => {
        const {
            selectedUserForHistory,
            historyPageSize,
            historyFromDate,
            historyToDate
        } = this.state;
        if (!selectedUserForHistory) {
            this.setState({ historyLoading: false });
            return;
        }
        if (!historyFromDate || !historyToDate) {
            toast.error("Bắt buộc chọn từ ngày và đến ngày.");
            this.setState({ historyLoading: false });
            return;
        }
        if (historyFromDate > historyToDate) {
            toast.error("Thời gian bắt đầu phải nhỏ hơn hoặc bằng thời gian kết thúc.");
            this.setState({ historyLoading: false });
            return;
        }

        // /gem-history giờ trả về full theo khoảng filter, không còn phân trang.
        this.setState({ historyLoading: true });
        try {
            const response = await fetchRoomEarningGemHistory({
                userId: selectedUserForHistory.id,
                startTime: historyFromDate,
                endTime: historyToDate,
                cursor: null,
                pageSize: historyPageSize
            });
            const chunk = response.data || [];
            this.setState(prev => ({
                diamondHistory: chunk,
                historyNextCursor: "END",
                historyLoading: false
            }));
        } catch (e) {
            const msg =
                (e && e.response && e.response.data && e.response.data.message) ||
                "Có lỗi xảy ra khi tải lịch sử Kim Cương.";
            toast.error(msg);
            this.setState({ historyLoading: false });
        }
    };

    handleHistoryDateChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleHistorySearch = () => {
        this.setState(
            {
                diamondHistory: [],
                historyNextCursor: "END",
                historyLoading: true
            },
            () => {
                this.fetchHistoryPage(true);
            });
    };

    openWithdrawModal = (user) => {
        const withdrawable = user && user.withdrawableGem != null ? user.withdrawableGem : 0;
        const totalNow = user && user.totalGemNow != null ? user.totalGemNow : 0;
        const maxWithdraw = Math.floor((withdrawable || 0) * 1.0);
        this.setState({
            selectedUserForWithdraw: user,
            selectedUserForWithdrawId: user && user.id ? user.id : null,
            withdrawModalVisible: true,
            withdrawAmount: "",
            withdrawMethod: "CASH",
            withdrawSubmitting: false,
            availableDiamonds: withdrawable || 0,
            totalDiamondsNow: totalNow || 0,
            maxWithdrawDiamonds: maxWithdraw
        });
    };

    closeWithdrawModal = () => {
        this.setState({
            selectedUserForWithdraw: null,
            selectedUserForWithdrawId: null,
            withdrawModalVisible: false,
            withdrawAmount: "",
            withdrawMethod: "CASH",
            withdrawSubmitting: false,
            availableDiamonds: 0,
            totalDiamondsNow: 0,
            maxWithdrawDiamonds: 0
        });
    };

    handleWithdrawAmountChange = (e) => {
        const value = e.target.value;
        this.setState({ withdrawAmount: value });
    };

    handleWithdrawMethodChange = (e) => {
        this.setState({ withdrawMethod: e.target.value });
    };

    confirmWithdraw = async () => {
        const {
            withdrawAmount,
            withdrawMethod,
            availableDiamonds,
            maxWithdrawDiamonds,
            selectedUserForWithdraw,
            selectedUserForWithdrawId,
            results,
            withdrawSubmitting
        } = this.state;

        if (withdrawSubmitting) return;

        const amount = parseInt(withdrawAmount, 10);
        if (isNaN(amount) || amount < 100) {
            toast.error("Số lượng rút tối thiểu là 100.");
            return;
        }
        if (amount > availableDiamonds) {
            toast.error("Số lượng rút vượt quá Kim Cương khả dụng.");
            return;
        }
        if (amount > maxWithdrawDiamonds) {
            toast.error("Số lượng rút vượt quá Kim Cương có thể rút (tháng trước).");
            return;
        }
        if (!withdrawMethod) {
            toast.error("Vui lòng chọn hình thức rút.");
            return;
        }

        this.setState({ withdrawSubmitting: true });
        try {
            const response = await withdrawRoomEarningGem({
                userId: selectedUserForWithdrawId || (selectedUserForWithdraw && selectedUserForWithdraw.id),
                amount,
                exchangeMethod: withdrawMethod
            });

            const isSuccess = response && response.success !== false && response.status !== "FAILED";
            if (!isSuccess) {
                toast.error((response && response.message) || "Rút Kim Cương thất bại.");
                this.setState({ withdrawSubmitting: false });
                return;
            }

            const updatedResults = results.map(item => {
                const selectedId = selectedUserForWithdrawId != null ? selectedUserForWithdrawId : null;
                const itemId = item && item.id != null ? item.id : null;
                const isMatchById = selectedId != null && itemId != null && itemId === selectedId;
                const isMatchByUid = item && selectedUserForWithdraw && item.uid === selectedUserForWithdraw.uid;

                if (isMatchById || isMatchByUid) {
                    const currentWithdrawable = item && item.withdrawableGem != null ? item.withdrawableGem : 0;
                    const currentTotalGem = item && item.totalGemNow != null ? item.totalGemNow : 0;
                    return {
                        ...item,
                        withdrawableGem: Math.max(0, currentWithdrawable - amount),
                        totalGemNow: Math.max(0, currentTotalGem - amount)
                    };
                }
                return item;
            });

            this.setState({
                results: updatedResults,
                withdrawModalVisible: false,
                selectedUserForWithdraw: null,
                selectedUserForWithdrawId: null,
                withdrawAmount: "",
                withdrawMethod: "CASH",
                withdrawSubmitting: false,
                availableDiamonds: 0,
                totalDiamondsNow: 0,
                maxWithdrawDiamonds: 0
            });

            toast.success("Rút Kim Cương thành công.");
        } catch (e) {
            const msg =
                (e && e.response && e.response.data && e.response.data.message) ||
                "Có lỗi xảy ra khi rút Kim Cương.";
            toast.error(msg);
            this.setState({ withdrawSubmitting: false });
        }
    };

    renderTable() {
        const { results, loading, loadingMore } = this.state;

        if (loading && !loadingMore) {
            return (
                <tbody>
                    <tr>
                        <td colSpan="7" className="text-center">
                            Đang tải dữ liệu...
                        </td>
                    </tr>
                </tbody>
            );
        }

        if ((!results || results.length === 0) && !loadingMore) {
            return (
                <tbody>
                    <tr>
                        <td colSpan="7" className="text-center">
                            Không có dữ liệu.
                        </td>
                    </tr>
                </tbody>
            );
        }

        return (
            <tbody>
                {results.map((item, index) => (
                    <tr key={item.uid}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{item.uid}</td>
                        <td className="text-center">{item.ownerName}</td>
                        <td className="text-center">{item.role || ""}</td>
                        <td className="text-center">
                            {formatInt(item.validMinutesInRange)} phút{" "}
                            <button
                                type="button"
                                className="btn btn-link btn-sm p-0 ml-1"
                                onClick={() => this.openOnlineDetailModal(item)}
                                title="Xem chi tiết theo từng phòng làm chủ"
                            >
                                <i className="fa fa-eye" aria-hidden="true"></i>
                            </button>
                        </td>
                        <td className="text-right">
                            {formatInt(item.totalGemNow)}{" "}
                            <button
                                type="button"
                                className="btn btn-link btn-sm p-0 ml-1"
                                onClick={() => this.openHistoryModal(item)}
                                title="Lịch sử Kim Cương"
                            >
                                <i className="fa fa-eye" aria-hidden="true"></i>
                            </button>
                        </td>
                        <td className="text-center">
                            <button
                                className="btn btn-sm btn-warning"
                                onClick={() => this.openWithdrawModal(item)}
                            >
                                Rút Kim Cương
                            </button>
                        </td>
                    </tr>
                ))}
                {loadingMore && (
                    <tr>
                        <td colSpan="7" className="text-center text-muted">
                            Đang tải thêm...
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    renderHistoryModal() {
        const {
            historyModalVisible,
            selectedUserForHistory,
            diamondHistory,
            historyPageSize,
            historyLoading,
            historyFromDate,
            historyToDate
        } = this.state;
        if (!historyModalVisible || !selectedUserForHistory) {
            return null;
        }

        const isEmpty =
            !historyLoading && diamondHistory.length === 0;
        const showHistoryTable = !historyLoading;

        return (
            <>
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Lịch sử biến động Kim Cương - UID {selectedUserForHistory.uid} (
                                    {selectedUserForHistory.ownerName || ""})
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={this.closeHistoryModal}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>Thời gian bắt đầu</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="historyFromDate"
                                            value={historyFromDate}
                                            onChange={this.handleHistoryDateChange}
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Thời gian kết thúc</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="historyToDate"
                                            value={historyToDate}
                                            onChange={this.handleHistoryDateChange}
                                        />
                                    </div>
                                    <div className="form-group col-md-4 d-flex align-items-end">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={this.handleHistorySearch}
                                            disabled={historyLoading}
                                        >
                                            Tìm kiếm
                                        </button>
                                    </div>
                                </div>
                                {historyLoading && (
                                    <div className="text-center py-3">Đang tải...</div>
                                )}
                                {showHistoryTable && (
                                    <>
                                        <table className="table table-striped table-hover table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Thời gian</th>
                                                    <th className="text-center">Loại giao dịch</th>
                                                    <th className="text-center">Phút online hợp lệ</th>
                                                    <th className="text-center">Kim Cương</th>
                                                    <th className="text-center">Tổng KC</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isEmpty && (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            Không có lịch sử Kim Cương.
                                                        </td>
                                                    </tr>
                                                )}
                                                {diamondHistory.map((history, idx) => (
                                                    <tr key={idx}>
                                                        <td className="text-center">
                                                            {formatHistoryTimeByType(history.time, history.type)}
                                                        </td>
                                                        <td className="text-center">
                                                            {formatHistoryTransactionLabel(history.type, history.category)}
                                                        </td>
                                                        <td className="text-right">
                                                            {formatHistoryInteger(history.validOnlineMinutes)}
                                                        </td>
                                                        <td
                                                            className={
                                                                "text-right " +
                                                                (history.type === "INCREASE" ? "text-success" : "text-danger")
                                                            }
                                                        >
                                                            {formatHistorySignedInteger(history.amount || 0)}
                                                        </td>
                                                        <td className="text-right">
                                                            {history.balanceAfter != null ? formatHistoryInteger(history.balanceAfter) : ""}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={this.closeHistoryModal}
                                >
                                    Đóng
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show" />
            </>
        );
    }

    openOnlineDetailModal = (ownerRow) => {
        const rooms = Array.isArray(ownerRow && ownerRow.rooms) ? ownerRow.rooms : [];
        const normalizedRooms = rooms.map(r => ({
            roomId: r && r.roomId,
            roomName: (r && r.roomName) || "",
            validOnlineTimer: r && r.validOnlineTimer,
            diamonds: r && r.diamonds
        }));
        this.setState({
            selectedOwnerForOnlineDetail: ownerRow,
            ownerRoomsDetailList: normalizedRooms,
            onlineDetailModalVisible: true
        });
    };

    closeOnlineDetailModal = () => {
        this.setState({
            selectedOwnerForOnlineDetail: null,
            ownerRoomsDetailList: [],
            onlineDetailModalVisible: false
        });
    };

    renderOnlineDetailModal() {
        const {
            onlineDetailModalVisible,
            selectedOwnerForOnlineDetail,
            ownerRoomsDetailList
        } = this.state;

        if (!onlineDetailModalVisible || !selectedOwnerForOnlineDetail) {
            return null;
        }

        const isEmpty = !ownerRoomsDetailList || ownerRoomsDetailList.length === 0;

        return (
            <>
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Phòng làm chủ - UID {selectedOwnerForOnlineDetail.uid} (
                                    {selectedOwnerForOnlineDetail.ownerName})
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={this.closeOnlineDetailModal}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <table className="table table-striped table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center">ID phòng</th>
                                            <th className="text-center">Tên phòng</th>
                                            <th className="text-center">Thời gian online hợp lệ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isEmpty && (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    Chưa có dữ liệu thời gian online hợp lệ cho các phòng trong khoảng thời gian này.
                                                </td>
                                            </tr>
                                        )}
                                        {ownerRoomsDetailList.map(room => (
                                            <tr key={room.roomId}>
                                                <td className="text-center">{room.roomId}</td>
                                                <td>{room.roomName}</td>
                                                <td className="text-center">
                                                    {formatInt(room.validOnlineTimer)} phút
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={this.closeOnlineDetailModal}
                                >
                                    Đóng
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show" />
            </>
        );
    }

    renderWithdrawModal() {
        const {
            withdrawModalVisible,
            selectedUserForWithdraw,
            availableDiamonds,
            totalDiamondsNow,
            withdrawAmount,
            withdrawMethod,
            withdrawSubmitting
        } = this.state;

        if (!withdrawModalVisible || !selectedUserForWithdraw) {
            return null;
        }

        const isWithdrawDisabledByAvailable = floorNumber(availableDiamonds) < 100;

        return (
            <>
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Rút Kim Cương - UID {selectedUserForWithdraw.uid} (
                                    {selectedUserForWithdraw.ownerName || ""})
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={this.closeWithdrawModal}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Tổng Kim Cương hiện tại:{" "}
                                    <strong>{formatInt(totalDiamondsNow)}</strong>
                                </p>
                                <p>
                                    Kim Cương khả dụng:{" "}
                                    <strong>{formatInt(availableDiamonds)}</strong>
                                </p>
                                {isWithdrawDisabledByAvailable && (
                                    <div className="alert alert-warning py-2">
                                        Cần tối thiểu 100 KC khả dụng để rút.
                                    </div>
                                )}
                                <div className="form-group">
                                    <label>Số lượng cần rút</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={withdrawAmount}
                                        onChange={this.handleWithdrawAmountChange}
                                        min="100"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Hình thức rút</label>
                                    <div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="withdrawMethod"
                                                id="withdrawMethodCash"
                                                value="CASH"
                                                checked={withdrawMethod === "CASH"}
                                                onChange={this.handleWithdrawMethodChange}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="withdrawMethodCash"
                                            >
                                                CASH
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="withdrawMethod"
                                                id="withdrawMethodICoin"
                                                value="ICOIN"
                                                checked={withdrawMethod === "ICOIN"}
                                                onChange={this.handleWithdrawMethodChange}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="withdrawMethodICoin"
                                            >
                                                ICOIN
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={this.closeWithdrawModal}
                                    disabled={withdrawSubmitting}
                                >
                                    Hủy
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.confirmWithdraw}
                                    disabled={withdrawSubmitting || isWithdrawDisabledByAvailable}
                                >
                                    {withdrawSubmitting ? "Đang xử lý..." : "Xác nhận"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show" />
            </>
        );
    }

    render() {
        const {
            searchUid,
            searchRole,
            searchFromDate,
            searchToDate,
            errorMessage,
            loading,
            loadingMore,
            pageSize,
            results,
            usersNextCursor
        } = this.state;

        return (
            <div id="content">
                <div className="container-fluid">
                    <h1 className="text-center">Quản lý giao dịch Kiếm tiền từ phòng</h1>
                    <hr />

                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="form-row">
                                <div className="form-group col-md-3">
                                    <label>UID chủ phòng</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="searchUid"
                                        placeholder="Nhập UID người dùng"
                                        value={searchUid}
                                        onChange={this.handleChange}
                                        onKeyDown={this.handleUidSearchKeyDown}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Role</label>
                                    <select
                                        className="form-control"
                                        name="searchRole"
                                        value={searchRole}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Tất cả</option>
                                        {ROOM_EARNING_ROLE_OPTIONS.map(role => (
                                            <option key={role} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Thời gian bắt đầu</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="searchFromDate"
                                        value={searchFromDate}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Thời gian kết thúc</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="searchToDate"
                                        value={searchToDate}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="form-group col-md-3 d-flex align-items-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary mr-2"
                                        onClick={this.handleSearch}
                                    >
                                        Tìm kiếm
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.handleRefresh}
                                    >
                                        Làm mới
                                    </button>
                                </div>
                            </div>
                            {errorMessage && (
                                <div className="alert alert-danger mt-2">{errorMessage}</div>
                            )}
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Danh sách kết quả</h5>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" style={{ width: "60px" }}>#</th>
                                            <th className="text-center">UID chủ phòng</th>
                                            <th className="text-center">Tên chủ phòng</th>
                                            <th className="text-center">Role</th>
                                            <th className="text-center">Thời gian online hợp lệ</th>
                                            <th className="text-center">Kim cương còn</th>
                                            <th className="text-center">Hành động</th>
                                        </tr>
                                    </thead>
                                    {this.renderTable()}
                                </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                                <div>
                                    Đã hiển thị: <strong>{results.length}</strong> bản ghi
                                    {usersNextCursor && usersNextCursor !== "END" ? " (còn có thể tải thêm)" : ""}
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        disabled={
                                            loading ||
                                            loadingMore ||
                                            !usersNextCursor ||
                                            usersNextCursor === "END" ||
                                            false
                                        }
                                        onClick={async () => {
                                            if (!usersNextCursor || usersNextCursor === "END") return;
                                            if (!searchFromDate || !searchToDate) {
                                                this.setState({
                                                    errorMessage: "Bắt buộc chọn từ ngày và đến ngày (yyyy-MM-dd)."
                                                });
                                                return;
                                            }
                                            if (searchFromDate > searchToDate) {
                                                this.setState({
                                                    errorMessage: "Thời gian bắt đầu phải nhỏ hơn hoặc bằng thời gian kết thúc."
                                                });
                                                return;
                                            }

                                            const trimmedUid = (searchUid || "").trim();
                                            const uidNumber = trimmedUid !== "" ? parseInt(trimmedUid, 10) : NaN;
                                            const uidParam =
                                                trimmedUid !== "" && !isNaN(uidNumber) ? uidNumber : null;
                                            this.setState({ loadingMore: true });
                                            try {
                                                const response = await fetchRoomEarningUsers({
                                                    uid: uidParam,
                                                    role: searchRole,
                                                    startTime: searchFromDate,
                                                    endTime: searchToDate,
                                                    cursor: usersNextCursor,
                                                    pageSize: pageSize
                                                });
                                                const chunk = response.data || [];
                                                this.setState(prev => ({
                                                    results: [...prev.results, ...chunk],
                                                    usersNextCursor: response.nextCursor || "END",
                                                    loadingMore: false
                                                }));
                                            } catch (e) {
                                                const msg = (e && e.response && e.response.data && e.response.data.message) || null;
                                                this.setState({
                                                    loadingMore: false,
                                                    errorMessage: msg || "Có lỗi xảy ra khi tải thêm dữ liệu."
                                                });
                                            }
                                        }}
                                    >
                                        Tải thêm
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.renderHistoryModal()}
                {this.renderWithdrawModal()}
                {this.renderOnlineDetailModal()}
            </div>
        );
    }
}

